<template>
  <div class="width-100 min-height">
    <div id="body-id" class="flex-column align-items-center justify-content-start min-height width-100" style="padding: 3%; background: #f6f6f6">
      <div
        v-if="itemDetail"
        class="position-relative width-100 br-reg flex-row align-items-center justify-content-center overflow-h"
        @click="$router.push({ path: '/luckyDrawDetails', query: { id: itemDetail.id } })"
        :style="{ height: (topCardWidth / 721) * 344 + 'px' }"
      >
        <div
          class="position-absolute bg-price width-100 flex-row justify-content-around align-items-center"
          :style="{ height: (topCardWidth / 721) * 67 + 'px', zIndex: 2, bottom: 0, right: 0, alignItems: 'baseline' }"
        >
          <div class="width-40 white fs-sml fm-sh-regular textAlign-c">
            市场价：￥<span class="white fs-big fm-sh-bold">{{ itemDetail.goods_price ? itemDetail.goods_price : '' }}</span>
          </div>
          <div class="width-55 height-100 flex-column align-items-center justify-content-center">
            <!-- <van-count-down :time="itemDetail.endTime" format="DD:HH:mm:ss">
              <template #default="timeData">
                <div class="flex-row align-items-end justify-content-around width-100">
                  <span class="fs-sml black fm-sh-medium" style="transform: scale(0.8)">结束倒计时</span>
                  <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card fm-sh-light">
                    {{ timeData.days }}
                  </span>
                  <span class="colon">:</span>
                  <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card fm-sh-light">
                    {{ timeData.hours }}
                  </span>
                  <span class="colon">:</span>
                  <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card fm-sh-light">
                    {{ timeData.minutes }}
                  </span>
                  <span class="colon">:</span>
                  <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card fm-sh-light">
                    {{ timeData.seconds }}
                  </span>
                </div>
              </template>
            </van-count-down> -->
            <div class="flex-row align-items-end justify-content-around width-100">
              <span class="fs-sml black fm-sh-medium" style="transform: scale(0.8)">结束倒计时</span>
              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card">{{ dayTime }}</span
              >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card">{{ hourTime }}</span
              >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card">{{ minuteTime }}</span
              >:
              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="white time-card">{{ secondTime }}</span>
            </div>
          </div>
        </div>
        <van-image :src="itemDetail.goods_picture_url" style="z-index: 1" fit="contain" width="100%" :height="(topCardWidth / 721) * 344 + 'px'" />
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="manuscriptList.length == 0 ? '' : '没有更多了'"
        @load="onLoad"
        class="width-100"
      >
        <div v-for="(item, key) in manuscriptList" :key="key" class="width-100 margin-ts bg-white br-reg" style="padding: 3%">
          <div class="flex-row width-100 align-items-center justify-content-spaceBetween" style="position: relative">
            <div class="fm-sh-medium fs-mid" style="z-index: 2">{{ item.name }}</div>
            <div class="fs-sml fm-sh-regular" :style="{ color: item.lottery_state == 1 ? '#979797' : '#ff8526' }">
              {{ item.lottery_state == 1 ? '已开奖' : '待开奖' }}
            </div>
            <van-image
              :src="require('../assets/image/home/title-bottom.png')"
              style="position: absolute; z-index: 1; bottom: 2px; left: 1px"
              width="3rem"
              height="0.3125rem"
              fit="fill"
            />
          </div>
          <div
            @click="$router.push({ path: '/luckyDrawDetails', query: { id: item.id } })"
            :class="['width-100 margin-ts flex-row align-items-star justify-content-spaceBetween position-relative', 'border-b']"
          >
            <div
              class="br-reg flex-row align-items-center justify-content-center"
              :style="{ width: (topCardWidth / 721) * 160 + 'px', height: (topCardWidth / 721) * 160 + 'px', border: '1px solid #e3e3e3' }"
            >
              <van-image
                :src="item.goods_picture_url ? item.goods_picture_url : require('../assets/image/home/computer.png')"
                width="90%"
                fit="contain"
                height="90%"
              />
            </div>
            <div class="width-70">
              <div class="fs-mid-sml black fm-sh-medium">{{ item.goods_name }}</div>
              <div class="fs-sml grey fm-sh-medium" v-if="item.lottery_code">中奖号码：{{ item.lottery_code }}</div>
              <div class="fs-sml grey fm-sh-medium" v-if="item.end_time">活动结束时间：{{ item.end_time }}</div>
              <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
                <div class="fs-sml red fm-sh-medium" v-if="item.goods_price">价格：{{ item.goods_price }}</div>
                <div class="fs-sml grey fm-sh-medium" v-if="item.goods_num">数量：{{ item.goods_num }}</div>
              </div>
            </div>
          </div>
          <div class="flex-row align-items-center justify-content-spaceBetween">
            <div class="fs-mid-sml fm-sh-medium">我的抽奖码</div>
            <div v-if="!item.show" class="fs-sml fm-sh-regular black">
              <van-icon color="black" name="search" size="12" @click="getActivityMemberTicketLists(item.id)" />查看
            </div>
            <div v-else class="fs-sml fm-sh-regular black">
              <van-icon name="arrow-up" size="12" color="black" @click="hideTicketLists(item.id)" />收起
            </div>
          </div>
          <div
            v-if="item.show && item.lottery_state == 2"
            class="width-100 flex-row align-items-center justify-content-start"
            style="flex-wrap: wrap"
          >
            <div
              v-for="(its, k) in item.lottery_array"
              :key="k"
              class="fs-sml grey-999 fm-sh-medium margin-rs margin-ts"
              style="padding: 1px 5px; background: #f7f7f7"
            >
              {{ its.lottery_ticket }}
            </div>
            <div v-if="item.lottery_array.length == 0" class="grey-999 fw-mid textAlign-c width-100" style="height: 3rem; line-height: 3rem">
              暂无奖券
            </div>
          </div>
          <div
            v-else-if="item.show && item.is_winner != 1 && item.lottery_state == 1"
            class="grey-999 fw-mid textAlign-c"
            style="height: 3rem; line-height: 3rem"
          >
            {{ item.not_winner_tips }}
          </div>
          <div
            v-else-if="item.show && item.is_winner == 1 && item.lottery_state == 1"
            class="grey-999 fw-mid textAlign-c"
            style="height: 3rem; line-height: 3rem"
          >
            已开奖，请前往中奖记录查看。
          </div>
        </div>
        <van-empty
          v-if="manuscriptList.length == 0"
          class="custom-image"
          :image="require('../assets/image/prizeManagement/empty-image.png')"
          description="暂无数据"
        />
      </van-list>
    </div>
    <div style="margin-bottom: 80px"></div>
    <Tabbar active="2" />
  </div>
</template>

<script>
let interval = null;
import Tabbar from '../components/tabbar.vue';
import { getActivityRecordLists, getActivityMemberTicketLists } from '@/api/manuscriptIndex';
export default {
  data() {
    return {
      dayTime: 0,
      hourTime: 0,
      minuteTime: 0,
      secondTime: 0,
      manuscriptList: [],
      itemDetail: null,
      topCardWidth: 0,
      searchObj: {
        page: 0
      },
      loading: false,
      finished: false
    };
  },
  components: {
    Tabbar
  },
  beforeMount() {
    this.$nextTick(() => {
      this.topCardWidth = document.getElementById('body-id').clientWidth;
    });
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(interval);
    next();
  },
  methods: {
    async getActivityRecordLists() {
      await getActivityRecordLists({ page: this.searchObj.page })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.lists.length == 0) {
              this.finished = true;
            } else {
              this.itemDetail = res.data.activity_info;
              console.log(!!this.itemDetail, 'itemDetail');
              if (res.data.activity_info != null) {
                clearInterval(interval);
                interval = setInterval(() => {
                  let times = this.daysDistance(res.data.activity_info.end_time.replace(/-/g, '/'), new Date());
                  let day = Math.floor(times / 1000 / 3600 / 24);
                  let hour = Math.floor(times / 1000 / 3600);
                  let minutes = Math.floor(times / 1000 / 60);
                  this.dayTime = Math.floor(times / 1000 / 3600 / 24);
                  this.hourTime = Math.floor(times / 1000 / 3600) - day * 24;
                  this.minuteTime = Math.floor(times / 1000 / 60) - hour * 60;
                  this.secondTime = Math.floor(times / 1000) - minutes * 60;
                }, 1000);
              }
              this.manuscriptList = this.manuscriptList.concat(res.data.lists);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
    //date1和date2是2019-06-18格式
    daysDistance(date1, date2) {
      //parse() 是 Date 的一个静态方法 , 所以应该使用 Date.parse() 来调用，而不是作为 Date 的实例方法。返回该日期距离 1970/1/1 午夜时间的毫秒数
      date1 = Date.parse(date1);
      date2 = Date.parse(date2);
      //计算两个日期之间相差的毫秒数的绝对值
      var ms = Math.abs(date2 - date1);
      //毫秒数除以一天的毫秒数,就得到了天数
      return ms;
    },
    getActivityMemberTicketLists(item) {
      getActivityMemberTicketLists({ id: item }).then((res) => {
        console.log(res);
        this.manuscriptList = this.manuscriptList.map((its) => {
          if (its.id == item) {
            its.show = true;
            its.lottery_array = res.data;
          }
          return its;
        });
      });
    },
    onLoad() {
      this.searchObj.page += 1;
      this.getActivityRecordLists();
    },
    hideTicketLists(id) {
      this.manuscriptList = this.manuscriptList.map((its) => {
        if (its.id == id) {
          its.show = false;
        }
        return its;
      });
    }
  }
};
</script>

<style scoped>
.bg-price {
  background-image: url('../assets/image/manuscriptIndex/price-image.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.time-card {
  border-radius: 0.35rem;
  background: #1e67f7;
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  line-height: 1.3rem;
  font-size: 12px;
}
.prize-draw-code-item {
  font-size: 12px;
  color: #999;
  background: #f7f7f7;
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  border-radius: 0.2rem;
}
</style>
